import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import HeaderBg from "../../images/careers/pexels-anna-nekrashevich-6801872.jpg"

import OpenPositionProf from "../../components/openPositionProf"

const InvestmentTrading = ({ data }) => {
  const investTrade = data.allSanityOpenPositions.edges.map((item) => item.node)
  // console.log("investTrade", investTrade)
  return (
    <Layout>
      <SEO title="Investing & Trading" />
      <div className="page-header">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-xl-10">
              <div className="header-text">
                <h1 className="text-black mb-4">Investing & Trading</h1>
                {/* <p className="lead">
                  Explore the latest news, insights, exclusive interviews, and
                  media coverage on Bay Street Capital Holdings
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div
          className="header-bg"
          style={{ backgroundImage: `url(${HeaderBg})` }}
        />
      </div>
      <div className="careers-page">
        {/* <div className="careers-hero positions-investment has-overlay">
          <div className="container">
            <h1 className="display-4 text-center">Investing & Trading</h1>
          </div>
        </div> */}

        <div className="py-110">
          <div className="container">
            <h2 class="section-title text-center">Open Positions</h2>
            <OpenPositionProf jobs={investTrade} />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default InvestmentTrading
export const invtPageQuery = graphql`
  query {
    allSanityOpenPositions(
      filter: {
        careerCategories: {
          elemMatch: { title: { eq: "Investment & Trading" } }
        }
      }
    ) {
      edges {
        node {
          title
          slug {
            current
          }
          excerpt
          location
          careerCategories {
            title
          }
          _createdAt(formatString: "MM-DD-YY")
        }
      }
    }
  }
`
